import React from 'react';
import { Box, darken, Divider, Stack, styled, Typography, Link } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import PolicyIcon from '@mui/icons-material/Policy';
import { FaPhoneAlt } from 'react-icons/fa';
import { RiCustomerService2Fill } from 'react-icons/ri';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { Business, CancelOutlined, MonetizationOnOutlined } from '@mui/icons-material';
import FooterTitle from './FooterTitle';
import FooterLink from './FooterLink';
import { Colors } from '../style/theme';

const CombinedLink = () => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    <TaskAltIcon />
    <span>Delivery</span>
    <CancelOutlined />
    <span>Cancellation &</span>
    <MonetizationOnOutlined />
    <span>Refund</span>
  </div>
);

const Footer = () => {
  const StackColumn = styled(Stack)(() => ({
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flex: 1,
    gap: 10,
    textAlign: 'center',
    minWidth: 0,
    padding: '0 15px',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
  }));

  const BoxRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: Colors.primary,
    color: Colors.white,
    flex: 1,
    padding: '40px 0',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 30,
    },
  }));

  return (
    <BoxRow component="footer">
      <StackColumn>
        <FooterTitle text="Contact" />
        <FooterLink text="info@watchnod.com" link="mailto:info@watchnod.com" icon={<MailOutlineIcon sx={{ mr: 1 }} />} />
        <FooterLink
          text="Tylect Technologies Pvt Ltd, Plot No-490, Sachiwalaya Vihar, Mansarovar, Jaipur, Rajasthan, India, 302020"
          link="https://tylect.com/"
          icon={<Business />}
        />
        <FooterLink text="+91-9024862242" link="tel:+919024862242" icon={<FaPhoneAlt style={{ marginRight: '8px' }} />} />
        <FooterLink text="Contact Us" link="contact" icon={<RiCustomerService2Fill style={{ marginRight: '8px' }} />} />
      </StackColumn>

      <Divider orientation="vertical" flexItem />

      <StackColumn>
        <FooterTitle text="Help" />
        <FooterLink text="Terms of Service" link="terms-and-conditions" icon={<HelpOutlineIcon sx={{ mr: 1 }} />} />
        <FooterLink text="Customer Support" link="contact" icon={<QuestionAnswerIcon sx={{ mr: 1 }} />} />
        <FooterLink text="Privacy Policy" link="privacy-policy" icon={<PolicyIcon sx={{ mr: 1 }} />} />
        <FooterLink text={<CombinedLink />} link="service-delivery-policy" />
      </StackColumn>

      <Divider orientation="vertical" flexItem />

      <StackColumn>
        <FooterTitle text="About" />
        <FooterLink text="About Us" link="about" icon={<InfoOutlinedIcon sx={{ mr: 1 }} />} />
        <FooterLink text="FAQ" link="faq" icon={<QuestionAnswerIcon sx={{ mr: 1 }} />} />
      </StackColumn>

      <Divider orientation="vertical" flexItem />

      <StackColumn>
        <FooterTitle text="WatchNod" />
        <Stack direction="row" spacing={2} justifyContent="center">
          <Link
            href="https://www.instagram.com/tylect_technologies"
            variant="body2"
            aria-label="Visit Tylect Technologies on Instagram"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: Colors.white,
              '&:hover': {
                color: Colors.blue,
              },
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <InstagramIcon />
          </Link>
          <Link
            href="https://www.linkedin.com/company/tylect/"
            variant="body2"
            aria-label="Visit Tylect Technologies on LinkedIn"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: Colors.white,
              '&:hover': {
                color: Colors.blue,
              },
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <LinkedInIcon />
          </Link>
        </Stack>
        <Typography variant="caption" component="p">
          &copy; 2024 WatchNod as <b> Tylect Technologies Pvt Ltd</b>.
        </Typography>
      </StackColumn>
    </BoxRow>
  );
};

export default Footer;
